"use strict";
import { useMemo } from "react";
import { isTokenOptionArray } from "components/TokenSelector/utils";
export function useOnchainItemListSection({
  sectionKey,
  options,
  rightElement,
  endElement,
  name
}) {
  return useMemo(() => {
    if (!options) {
      return void 0;
    }
    const is2DArray = options?.length > 0 && Array.isArray(options[0]);
    const hasData = is2DArray ? options.some((item) => isTokenOptionArray(item) && item.length > 0) : options.length > 0;
    return hasData ? [
      {
        sectionKey,
        data: options,
        name,
        rightElement,
        endElement
      }
    ] : void 0;
  }, [name, rightElement, endElement, sectionKey, options]);
}
